var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"is-fullheight-with-navbar"},[(_vm.component != 'no-survey')?_c('div',[_c('logo'),_vm._v(" "),_c('intro'),_vm._v(" "),_c(_vm.component,{tag:"component",attrs:{"introText":_vm.introText,"startButtonText":_vm.startButtonText},on:{"form-status":_vm.handleEvent}})],1):_c('div',[_c('no-survey')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1df30056","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/BasicForm.vue
// module id = null
// module chunks = 